export type PageMockKind = 'cover' | 'icemap' | 'lessoncard' | 'circuit' | 'fieldcard'

export type LookInsidePage = {
  /** Real page screenshot. When set, it replaces the CSS preview. */
  src?: string
  /** CSS preview of the page, in the product identity. */
  mock: PageMockKind
  caption: string
}

/**
 * PENDING: export these five pages from Volume 1 as images and paste each
 * URL into `src`. Until then the carousel shows faithful CSS previews.
 */
export const lookInsidePages: LookInsidePage[] = [
  { mock: 'cover', caption: 'The cover: Volume 1, First Glides' },
  { mock: 'icemap', caption: 'The Ice Map: where each lane skates, waits and rotates' },
  { mock: 'lessoncard', caption: 'Week 4 Lesson Card: the whole class at a glance' },
  { mock: 'circuit', caption: 'Week 4 circuit: one skill, three lanes' },
  { mock: 'fieldcard', caption: 'The whole volume on one field card' },
]
